import { Link } from "react-router-dom";

const categories = [
  {
    type: "电影",
    to: "/category/电影",
    count: "21 部",
    desc: "科幻、悬疑、动作与剧情大片，覆盖多种题材的高清电影资源。",
    icon: "ri-movie-2-line",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20warm%20orange%20abstract%20cinema%20light%20flares%20and%20film%20strip%20texture%20on%20a%20dark%20background%2C%20moody%20atmospheric%2C%20artistic%20high%20contrast%20composition&width=800&height=600&seq=cat-movie&orientation=landscape",
  },
  {
    type: "电视剧",
    to: "/category/电视剧",
    count: "21 部",
    desc: "都市、悬疑、家庭与青春题材连续剧集，一集接一集停不下来。",
    icon: "ri-tv-2-line",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20cozy%20living%20room%20at%20night%20with%20a%20glowing%20television%20screen%2C%20warm%20orange%20lamplight%20with%20cool%20teal%20shadows%2C%20moody%20atmospheric%2C%20high%20contrast&width=800&height=600&seq=cat-tv&orientation=landscape",
  },
  {
    type: "短视频",
    to: "/category/短视频",
    count: "21 条",
    desc: "美食、旅行、萌宠与生活技巧，短小精悍的精彩内容随时开刷。",
    icon: "ri-clapperboard-line",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20phone%20screen%20glow%20on%20a%20dark%20desk%20with%20warm%20orange%20accent%20light%20and%20teal%20reflections%2C%20modern%20minimal%20atmospheric%20high%20contrast%20composition&width=800&height=600&seq=cat-short&orientation=landscape",
  },
];

export default function CategoryEntries() {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
      {categories.map((c) => (
        <Link
          key={c.type}
          to={c.to}
          className="group relative block h-56 rounded-lg overflow-hidden border border-background-200/60 hover:border-primary-500/70 transition-all duration-300 cursor-pointer"
        >
          <img
            src={c.image}
            alt={`${c.type}分类封面`}
            title={`${c.type} - 黄瓜视频App分类`}
            className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-background-950/95 via-background-950/50 to-background-950/20" />
          <div className="relative z-10 h-full p-5 flex flex-col justify-end">
            <span className="w-10 h-10 rounded-lg bg-primary-500 text-background-950 flex items-center justify-center mb-3">
              <i className={`${c.icon} text-xl`} />
            </span>
            <div className="flex items-center gap-2">
              <h3 className="text-xl font-heading font-bold text-foreground-950">{c.type}</h3>
              <span className="px-2 py-0.5 rounded-md text-xs font-label bg-accent-500/90 text-background-950">{c.count}</span>
            </div>
            <p className="mt-2 text-sm text-foreground-300 leading-relaxed">{c.desc}</p>
            <span className="mt-3 inline-flex items-center gap-1 text-sm text-primary-400 group-hover:gap-2 transition-all">
              进入分类
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
            </span>
          </div>
        </Link>
      ))}
    </div>
  );
}